/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Move_Word_DownInputs */

const en_shortcut_keys_desc_move_word_down = /** @type {(inputs: Shortcut_Keys_Desc_Move_Word_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move a single word down to the next line`)
};

const fr_shortcut_keys_desc_move_word_down = /** @type {(inputs: Shortcut_Keys_Desc_Move_Word_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deplacer un mot vers la ligne suivante`)
};

const de_shortcut_keys_desc_move_word_down = /** @type {(inputs: Shortcut_Keys_Desc_Move_Word_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verschiebe ein einzelnes Wort in die nächste Zeile.`)
};

const it_shortcut_keys_desc_move_word_down = /** @type {(inputs: Shortcut_Keys_Desc_Move_Word_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sposta una singola parola alla riga successiva`)
};

const ru_shortcut_keys_desc_move_word_down = /** @type {(inputs: Shortcut_Keys_Desc_Move_Word_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переместите одно слово на следующую строку.`)
};

const es_shortcut_keys_desc_move_word_down = /** @type {(inputs: Shortcut_Keys_Desc_Move_Word_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mover una sola palabra a la siguiente línea`)
};

const zh_cn2_shortcut_keys_desc_move_word_down = /** @type {(inputs: Shortcut_Keys_Desc_Move_Word_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将一个单词向下移动到下一行。`)
};

const ja_shortcut_keys_desc_move_word_down = /** @type {(inputs: Shortcut_Keys_Desc_Move_Word_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1つの単語を次の行に移動する`)
};

const hi_shortcut_keys_desc_move_word_down = /** @type {(inputs: Shortcut_Keys_Desc_Move_Word_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक शब्द को नीचे अगली पंक्ति में ले जाएं`)
};

const pt_pt2_shortcut_keys_desc_move_word_down = /** @type {(inputs: Shortcut_Keys_Desc_Move_Word_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mova uma única palavra para a linha seguinte.`)
};

/**
* | output |
* | --- |
* | "Move a single word down to the next line" |
*
* @param {Shortcut_Keys_Desc_Move_Word_DownInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_move_word_down = /** @type {((inputs?: Shortcut_Keys_Desc_Move_Word_DownInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Move_Word_DownInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_move_word_down(inputs)
	if (locale === "de") return de_shortcut_keys_desc_move_word_down(inputs)
	if (locale === "it") return it_shortcut_keys_desc_move_word_down(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_move_word_down(inputs)
	if (locale === "es") return es_shortcut_keys_desc_move_word_down(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_move_word_down(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_move_word_down(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_move_word_down(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_move_word_down(inputs)
	return en_shortcut_keys_desc_move_word_down(inputs)
});